export default __webpack_public_path__ + "static/media/avatar.775aafc7.svg";